var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.task.content.component)?_c(_vm.questionComponent,_vm._g(_vm._b({ref:"question",tag:"component",attrs:{"task":_vm.task,"task-state":_vm.taskState}},'component',_vm.$attrs,false),_vm.$listeners)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }